import { buildCollection, buildProperty } from "@firecms/core";

type Integration = "epic" | "practice-fusion" | "smart-on-fhir";
type Environment = "production" | "sandbox";

type FHIRConnection = {
  active: boolean;
  name: string;
  integration: Integration;
  environment: Environment;
  serverUrl: string;
  tokenUrl: string;
  clientId: string;
  scope?: string;
};

export const fhirConnectionsCollections = buildCollection<FHIRConnection>({
  id: "fhir_connections",
  name: "FHIR Connections",
  group: "Appointment Manager",
  textSearchEnabled: true,
  path: "fhir_connections",
  properties: {
    active: buildProperty({
      name: "Active",
      dataType: "boolean",
      defaultValue: true,
    }),
    name: buildProperty({
      name: "Name",
      dataType: "string",
      validation: { required: true },
    }),
    integration: buildProperty({
      name: "Integration",
      validation: { required: true },
      dataType: "string",
      enumValues: {
        epic: {
          id: "epic",
          label: "Epic",
          color: "orangeDark",
        },
        "practice-fusion": {
          id: "practice-fusion",
          label: "Practice Fusion",
          color: "blueDarker",
        },
        "smart-on-fhir": {
          id: "smart-on-fhir",
          label: "SMART on FHIR",
          color: "blueLight",
        },
      },
    }),
    environment: buildProperty({
      name: "Environment",
      dataType: "string",
      enumValues: {
        production: "Production",
        sandbox: "Sandbox",
      },
      validation: { required: true },
    }),
    serverUrl: buildProperty({
      name: "Server URL",
      dataType: "string",
      validation: { required: true },
    }),
    tokenUrl: buildProperty({
      name: "Token URL",
      dataType: "string",
      validation: { required: true },
    }),
    clientId: buildProperty({
      name: "Client ID",
      dataType: "string",
      validation: { required: true },
    }),
    scope: buildProperty({
      name: "Scope",
      dataType: "string",
    }),
  },
});
